import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import ReadIcon from "@redotech/redo-icons/mail-01.svg";
import { ExistsFilterOperator } from "@redotech/redo-model/views/advanced-filters/exists-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ExistsTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const ReadStatusAdvancedFilter: ExistsTableFilter = {
  type: AdvancedFilterType.EXISTS,
  Icon: ReadIcon,
  operators: [ExistsFilterOperator.EXISTS, ExistsFilterOperator.NOT_EXISTS],
  data: supportTicketFilterData[SupportTicketFilterNames.READ_AT],
  boolDisplay: { trueDisplay: "Read", falseDisplay: "Unread" },
  displayName: "Read Status",
};
